import {
  Render3DGameObjectEventsMap,
  UISpriteGameObject,
} from "realms-engine-browser";
import { DamageNumber } from "./DamageNumber";
import { html } from "canvas-ui";
import {
  Scene,
  TimerGameObject,
  TweenGameObject,
  Vector3,
  vector3Add,
} from "realms-engine";

// The time before the damage fades out
const LIFETIME_MS = 800;
const FADE_OUT_TIME_MS = 300;
const START_FONT_SIZE = 100;
const END_FONT_SIZE = 30;
const FONT_SIZE_CHANGE_TIME_MS = 200;

interface DamageNumberGameObjectEventMap extends Render3DGameObjectEventsMap {
  onOpacityChange: number;
  onFontSizeChange: number;
}

export class DamageNumberGameObject extends UISpriteGameObject<DamageNumberGameObjectEventMap> {
  private lifetimeTimer: TimerGameObject;
  private fadeOutStartTimer: TimerGameObject;
  private opacity = 1;
  private opacityTween: TweenGameObject<number>;
  private fontSize = START_FONT_SIZE;
  private fontSizeTween: TweenGameObject<number>;

  constructor({
    value,
    spawnPosition,
  }: {
    value: number;
    spawnPosition: Vector3;
  }) {
    const canvasHeight = 350;
    const canvasWidth = 250;
    const scale = 0.1;
    super(
      {
        damageNumber: DamageNumber,
      },
      {
        canvasHeight,
        canvasWidth,
        scale,
      }
    );
    this.render(html`<damageNumber value=${value} gameObject=${this} />`);

    this.fadeOutStartTimer = this.addChild(new TimerGameObject());
    this.fadeOutStartTimer.addListener("onFinish", () => {
      this.opacityTween.tween(0, FADE_OUT_TIME_MS);
    });

    this.lifetimeTimer = this.addChild(new TimerGameObject());
    this.lifetimeTimer.addListener("onFinish", () => {
      this.removeFromParent();
    });

    this.opacityTween = this.addChild(
      new TweenGameObject(
        () => this.opacity,
        (v) => this.setOpacity(v)
      )
    );

    this.fontSizeTween = this.addChild(
      new TweenGameObject(
        () => this.fontSize,
        (v) => this.setFontSize(v)
      )
    );

    // Set a random position
    const randomValue = (range: number) => {
      const v = Math.random();
      return v * range * 2 - range;
    };
    let xValue = randomValue(5);
    const minOffset = 3;
    xValue = xValue > 0 ? minOffset + xValue : -1 * minOffset + xValue;
    const offset = {
      x: xValue,
      y: -5 + randomValue(2),
      z: 0,
    };
    this.setPosition(vector3Add(spawnPosition, offset));
  }

  getFontSize() {
    return this.fontSize;
  }

  setFontSize(size: number) {
    this.fontSize = size;
    this.dispatch("onFontSizeChange", size);
  }

  private setOpacity(opacity: number) {
    this.opacity = opacity;
    this.dispatch("onOpacityChange", opacity);
  }

  onInit(scene: Scene): void {
    this.lifetimeTimer.start(LIFETIME_MS);
    this.fadeOutStartTimer.start(LIFETIME_MS - FADE_OUT_TIME_MS);
    this.fontSizeTween.tween(END_FONT_SIZE, FONT_SIZE_CHANGE_TIME_MS);
    super.onInit(scene);
  }
}
